import { Activity, AlertTriangle, BatteryLow, Gauge, KeyRound, LogIn, LogOut, MapPinOff, Move, Power, Radio, Shield, Wifi, Wrench } from "lucide-react";

export const OFFLINE_MIN = 10;

export const STATUS = {
  moving: { label: "Bergerak", hex: "#10B981", cls: "text-emerald-500 bg-emerald-500/10 border-emerald-500/30" },
  idle: { label: "Idle", hex: "#F59E0B", cls: "text-amber-500 bg-amber-500/10 border-amber-500/30" },
  stopped: { label: "Berhenti", hex: "#3B82F6", cls: "text-blue-500 bg-blue-500/10 border-blue-500/30" },
  offline: { label: "Offline", hex: "#64748B", cls: "text-slate-400 bg-slate-500/10 border-slate-500/30" },
};

export function isGpsFresh(v) {
  if (!v?.gps_time) return false;
  const t = new Date(v.gps_time).getTime();
  return Number.isFinite(t) && Date.now() - t <= OFFLINE_MIN * 60000 && t <= Date.now() + 60000;
}

export function vehicleStatus(v) {
  if (!v?.server_time || Date.now() - new Date(v.server_time).getTime() > OFFLINE_MIN * 60000) return "offline";
  if (isGpsFresh(v) && (v.speed || 0) > 3) return "moving";
  if (v.acc === true) return "idle";
  if (v.acc === false) return "stopped";
  return "offline";
}

export const isOnline = (v) => vehicleStatus(v) !== "offline";

export const PRIORITY = {
  INFO: { label: "Info", cls: "text-sky-500 bg-sky-500/10 border-sky-500/30", dot: "bg-sky-500" },
  WARNING: { label: "Warning", cls: "text-amber-500 bg-amber-500/10 border-amber-500/30", dot: "bg-amber-500" },
  CRITICAL: { label: "Critical", cls: "text-red-500 bg-red-500/10 border-red-500/30", dot: "bg-red-500" },
};

export const EVENT_TYPES = {
  overspeed: { label: "Overspeed", icon: Gauge },
  geofence_enter: { label: "Masuk Geofence", icon: LogIn },
  geofence_exit: { label: "Keluar Geofence", icon: LogOut },
  acc_on: { label: "ACC ON", icon: KeyRound },
  acc_off: { label: "ACC OFF", icon: KeyRound },
  movement: { label: "Pergerakan Kendaraan", icon: Move },
  gps_offline: { label: "GPS Offline", icon: MapPinOff },
  gps_online: { label: "GPS Online", icon: Wifi },
  power_cut: { label: "Power Terputus", icon: Power },
  low_battery: { label: "Baterai Lemah", icon: BatteryLow },
  engine: { label: "Status Mesin", icon: Wrench },
  command: { label: "Perintah", icon: Radio },
  system: { label: "Sistem", icon: Shield },
};
export const eventMeta = (t) => EVENT_TYPES[t] || { label: t, icon: AlertTriangle };
export const SOURCES = { vehicle: "Kendaraan", geofence: "Geofence", alarm: "Alarm", system: "Sistem" };
export const VEHICLE_TYPES = { car: "Mobil", motorcycle: "Motor", truck: "Truk", van: "Van" };
export const ActivityIcon = Activity;

const pad = (n) => String(n).padStart(2, "0");
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "-";
export const fmtShort = (s) => (s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-");
export const fmtClock = (s) => (s ? new Date(s).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "-");

export function timeAgo(s) {
  if (!s) return "-";
  const d = Math.max(0, (Date.now() - new Date(s).getTime()) / 1000);
  if (d < 60) return `${Math.floor(d)} dtk lalu`;
  if (d < 3600) return `${Math.floor(d / 60)} mnt lalu`;
  if (d < 86400) return `${Math.floor(d / 3600)} jam lalu`;
  return `${Math.floor(d / 86400)} hari lalu`;
}

export function fmtDuration(sec) {
  if (sec == null) return "-";
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return h ? `${h}j ${m}m` : `${m}m ${Math.floor(sec % 60)}d`;
}

export const dateInput = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const toIso = (date, time = "00:00") => new Date(`${date}T${time}:00`).toISOString();
export const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
};

export function formatCell(val, fmt) {
  if (val == null || val === "") return "-";
  if (fmt === "datetime") return fmtShort(val);
  if (fmt === "duration") return fmtDuration(val);
  if (fmt === "speed") return `${Number(val).toFixed(0)} km/j`;
  if (fmt === "km") return Number(val).toFixed(2);
  return String(val);
}
